import React from 'react';
import RenderIf from 'components/RenderIf/RenderIf';
import { UncontrolledTooltip } from 'reactstrap';
import { IPeriodOptionValue } from 'views/ProFormaTable/types';
import { CASH_FLOW_TOOLTIP_MESSAGE } from 'views/ProFormaTable/constants';

export interface IPeriodCellValueProps {
    period: IPeriodOptionValue;
    value: number | string;
    cellClassName?: string;
    overlayingCellInput?: JSX.Element | null;
    tooltipId?: string | null;
    children?: React.ReactNode;
}

const PeriodCellValue = ({
    period, value, cellClassName, overlayingCellInput, children, tooltipId,
}: IPeriodCellValueProps) => (
    <>
        <RenderIf isTrue={!period.isPlaceholder}>
            <td className={`${cellClassName} align-middle`}>
                <RenderIf isTrue={overlayingCellInput}>
                    {overlayingCellInput}
                </RenderIf>
                {value}
            </td>
        </RenderIf>
        <RenderIf isTrue={period.isPlaceholder}>
            <td
                className={cellClassName ?? 'align-middle NSTable__tfoot__tr__td--grey-bg'}
                id={`${tooltipId}-tooltip`}
            >
                {children}
                <UncontrolledTooltip target={`${tooltipId}-tooltip`}>
                    {CASH_FLOW_TOOLTIP_MESSAGE}
                </UncontrolledTooltip>
            </td>
        </RenderIf>
    </>
);

export default PeriodCellValue;
